export const cpfMask = (value: string) =>
  value
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o primeiro ponto
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
    .replace(/(\d{3})(\d{2})$/, '$1-$2'); // Adiciona o traço

export const onlyNumbers = (value: string) => value.replace(/\D/g, ''); // Remove caracteres não numéricos;

export const cnpjMask = (value: string): string => {
  if (!value) return ''; // Retorna string vazia se o valor for nulo ou indefinido
  return value
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .slice(0, 14) // Limita a 14 caracteres (tamanho do CNPJ sem formatação)
    .replace(/^(\d{2})(\d)/, '$1.$2') // Adiciona o primeiro ponto após os dois primeiros dígitos
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') // Adiciona o segundo ponto após os próximos três dígitos
    .replace(/\.(\d{3})(\d)/, '.$1/$2') // Adiciona a barra após os próximos três dígitos
    .replace(/(\d{4})(\d)/, '$1-$2'); // Adiciona o traço antes dos dois últimos dígitos
};
